module.exports = __webpack_public_path__ + "img/94ae486.jpg";